import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Button } from 'foundations-components/transitional/components/Button';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export default function HelpfulButton({
  dataTestId,
  disabled,
  helpfulCount,
  onClickHelpful,
  tooltip,
  userMarkedHelpful
}) {
  const onClick = useCallback(() => {
    const clickPromise = onClickHelpful();
    if (clickPromise instanceof Promise) {
      clickPromise.catch(() => {
        FloatingAlertStore.addAlert({
          message: unescapedText('marketplace-ui-reviews.helpfulButton.error.message'),
          titleText: unescapedText('marketplace-ui-reviews.helpfulButton.error.titleText'),
          type: 'danger'
        });
      });
    }
  }, [onClickHelpful]);
  return /*#__PURE__*/_jsx(UITooltip, {
    title: tooltip || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-ui-reviews.actions.loginRequired"
    }),
    disabled: !disabled || !tooltip,
    children: /*#__PURE__*/_jsx(Button, {
      active: userMarkedHelpful,
      "data-test-id": dataTestId,
      disabled: disabled,
      marginInlineEnd: "200",
      onClick: onClick,
      size: "xs",
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-reviews.actions.helpful",
        options: {
          count: helpfulCount
        }
      })
    })
  });
}